if (!customElements.get('collection-list-toggle')) {
  customElements.define(
    'collection-list-toggle',
    class CollectionListToggle extends HTMLElement {
      constructor() {
        super()

        this.bindEvents()
      }

      bindEvents() {
        this.addEventListener('change', this.handleChange.bind(this))
      }

      handleChange(e) {
        e.preventDefault()

        const currCollection = this.closest('.collection-list').querySelector('.collection-list__collection.active')
        const collectionId = `#collection-list-${e.target.value}`
        const activeCollection = this.closest('.collection-list').querySelector(collectionId)

        if (currCollection == activeCollection) return

        currCollection.classList.remove('active')
        activeCollection.classList.add('active')
      }
    }
  )
}
